import React from "react";

const ActionModal = ({ show, title, onClose, onConfirm, type = "approve" }) => {
  if (!show) return null;

  const colorMap = {
    approve: "#027A48",
    reject: "#B42318",
    return: "#B76E00",
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <h4 style={{ margin: 0 }}>{title}</h4>

        <textarea
          placeholder="Enter comment (optional)"
          style={textarea}
        />

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
          <button onClick={onClose} style={secondaryButton}>Cancel</button>
          <button
            onClick={onConfirm}
            style={{ ...primaryButton, background: colorMap[type] }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 999,
};

const modal = {
  background: "#fff",
  padding: 20,
  borderRadius: 12,
  width: 400,
};

const textarea = {
  width: "100%",
  height: 100,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: 10,
  marginTop: 12,
};

const primaryButton = {
  border: 0,
  color: "#fff",
  padding: "10px 14px",
  borderRadius: 8,
  fontWeight: 900,
  cursor: "pointer",
};

const secondaryButton = {
  border: "1px solid #CBD5E1",
  background: "#fff",
  padding: "10px 14px",
  borderRadius: 8,
  cursor: "pointer",
};

export default ActionModal;